import { useXlsxExport } from '@hooks/useXlsxExport'
import { Box, Button, Typography } from '@mui/material'
import { FilterInput } from '@typings/graphql'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  filter?: FilterInput[]
  total?: number
  tourId?: string
}

export const ExportBookings: React.FC<Props> = ({ filter = [], tourId, total }) => {
  const { t } = useTranslation()

  const handleExport = useXlsxExport()

  const onHandleExport = async () => {
    await handleExport({
      path: `booking/export?filter=${JSON.stringify(filter)}${tourId ? `&tourId=${tourId}` : ''}`,
      name: 'booking',
      onError: (error: any) => {
        console.error(error)
      },
      onComplete: () => {}
    })
  }

  return (
    <Box
      sx={{
        position: 'relative'
      }}
    >
      <Button
        onClick={onHandleExport}
        variant="contained"
      >
        {t('common.export')}
      </Button>
      {!!total && (
        <Typography
          textAlign="right"
          sx={{
            fontWeight: 500,
            fontSize: '12px',
            color: 'grey.600',
            pt: 0.5,
            transform: 'translateY(100%)',
            position: 'absolute',
            right: 0,
            bottom: 0
          }}
        >
          {t('payment.exportPayments', { count: total })}
        </Typography>
      )}
    </Box>
  )
}
